(function () {
  const STORAGE_KEY = 'collectionGridCols';

  function applyCols(cols) {
    const grid = document.querySelector('.js-product-grid');
    if (!grid) return;
    grid.setAttribute('data-cols', String(cols));

    document.querySelectorAll('.cv-btn').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.cols === String(cols));
    });

    try { localStorage.setItem(STORAGE_KEY, String(cols)); } catch (e) {}
  }

  function initToggle() {
    const holder = document.querySelector('.cv-toggle');
    if (!holder) return;

    holder.addEventListener('click', (e) => {
      const btn = e.target.closest('.cv-btn');
      if (!btn) return;
      const cols = parseInt(btn.dataset.cols, 10);
      if (cols) applyCols(cols);
    });

    let initial = 3;
    try {
      const saved = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if ([3,4,6].includes(saved)) initial = saved;
    } catch (e) {}
    applyCols(initial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggle);
  } else {
    initToggle();
  }
})();
